import { AutoAttendantListItem } from '../../store/types/AutoAttendant';

export const selectId = (item: AutoAttendantListItem): number | string => {
    return item.extension_id || item.id;
};
